const storeToken = (value) => {
  if (value) {
    const { access, refresh } = value
    sessionStorage.setItem('access_token', access)
    sessionStorage.setItem('refresh_token', refresh)
  }
}

const getToken = () => {
  let access_token = sessionStorage.getItem('access_token')
  let refresh_token = sessionStorage.getItem('refresh_token')
  return { access_token, refresh_token }
}

const removeToken = () => {
  sessionStorage.removeItem('access_token')
  sessionStorage.removeItem('refresh_token')
  sessionStorage.removeItem('user_type')
}

// The user's role is known immediately at login (it's in the login response)
// but nothing else refreshes it until Header's own API call resolves. Persist
// it the same way as the tokens so the route guard can check it on the very
// first render after a login or page reload, not several renders later.
const storeUserType = (type) => {
  if (type) sessionStorage.setItem('user_type', type)
}

const getUserType = () => sessionStorage.getItem('user_type')

export { storeToken, getToken, removeToken, storeUserType, getUserType }